// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-header.less
// module id = 2784
// module chunks = 0 1